import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { DRBFMStageRun } from '../../../types/drbfm';

interface StageRunPanelProps {
  stageRuns: DRBFMStageRun[];
}

const statusOutline = (status: DRBFMStageRun['status']) => {
  if (status === 'completed') return 'border-success/50 text-success';
  if (status === 'failed') return 'border-destructive/50 text-destructive';
  return undefined;
};

const StageRunPanel: React.FC<StageRunPanelProps> = ({ stageRuns }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <h6 className="revy-cjk text-sm font-medium leading-[1.57]">
        {t('drbfm.workflow.stageRun.title', '実行履歴')}
      </h6>
      {stageRuns.length === 0 ? (
        <p className="revy-cjk text-sm leading-[1.6] text-muted-foreground">
          {t('drbfm.workflow.stageRun.empty', 'まだ実行履歴はありません。')}
        </p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {stageRuns.map((run) => (
            <Badge key={run.id} variant="outline" className={cn(statusOutline(run.status))}>
              {`${run.stage}: ${run.status}`}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};

export default StageRunPanel;
